export default "__VITE_ASSET__GnJ575zQ__"